// Phase 7b — Slack team-ping hook.
//
// Wraps POST /api/conversations/:id/slack-ping. The backend posts to Slack
// (if SLACK_WEBHOOK_URL is set) and persists a row to team_pings for audit.
// Returns { ok, posted, channel, pingId }.
//
// `posted: false` with `ok: true` means: webhook not configured yet, submission
// was logged to the database but nothing went out to Slack. The UI should
// still close the drawer and show a subtle "Saved — webhook not wired" note
// so Kimi knows it didn't actually ping anyone.

import { useMutation } from '@tanstack/react-query';
import { apiPost } from '@/lib/api';

export type SlackPingCategory = 'question' | 'heads-up' | 'escalation' | 'fyi';

export interface SlackPingBody {
  body: string;
  category?: SlackPingCategory;
}

export interface SlackPingResponse {
  ok: true;
  posted: boolean;
  channel: string;
  pingId: string | null;
}

export function useSlackPing(conversationId: string | undefined) {
  return useMutation({
    mutationFn: async (payload: SlackPingBody): Promise<SlackPingResponse> => {
      if (!conversationId) throw new Error('Missing conversation id');
      return apiPost<SlackPingResponse, SlackPingBody>(
        `/api/conversations/${conversationId}/slack-ping`,
        payload,
      );
    },
  });
}
